firebird.factory('videoLowPerformanceService', [
    '$timeout',
    'logService',
    'helperService',
    'configService',
    'meetingService',
    'analyticsWrapperService',
    'videoGlobalService',
    'localizationService',
    'videoroomService',
    'growlService',
    function (
        $timeout,
        logService,
        helperService,
        configService,
        meetingService,
        analyticsWrapperService,
        videoGlobalService,
        localizationService,
        videoroomService,
        growlService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoLowPerformanceService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            self.initVideoLow = initVideoLow;
            self.initVideoLowAlt = initVideoLowAlt;
            self.setVideoLowConfig = setVideoLowConfig;
            self.getIsVideoLow = getIsVideoLow;
            self.getIsVideoLowLayout = getIsVideoLowLayout;

            // if true for any, then enable low performance mode (max 640x360 @ 15fps, 500-600kb/s)
            self.videoLowState = {
                // if set via URL param or settings
                config: undefined,
                // if set due to video count >= videoLowCount.
                count: undefined,
                // indicating CPU constrained or not (at level1 or default), only on Electron.
                appCpu: undefined,
                // indicating CPU constrained or not at level 2, only on Electron.
                // Causes lower bitrate and framerate. see videoLowConfig.
                appCpu2: undefined,
                // indicating server is overloaded.
                server: undefined,
                // indicating encodeTime is high, only when useEncodeTime is set.
                encodeTime: undefined,
                // indicating quality limitation count exceeded threshold.
                limit: undefined,
                // indicating low publish bitrate due to too many slow link events,
                // only used if bitrateLowConfig.type is videoLow.
                bitrate: undefined,
                //indicates we are in low performance mode due to being in screenshare
                screenshare: undefined
            };

            self.setVideoLow = setVideoLow;

            self.videoLowCount = 10; // if non-zero, then enable videoLowOnCount when video count reaches the number.
            self.videoFeedCount = 0; // current number of video feeds from video-feed-count event.

            self.useEncodeTime = false; // whether to use video tx encode time. only for browser (not electron).
            self.encodeTimeThreshold = 15; // milliseconds for encode time per frame to trigger video low mode. may be changed via URL param.

            self.trackEncodeTime = true; // only first time log the effect of encoding time and don't actually make a change

            // whether to adjust the desired webcam resolution when too many qualityLimitationResolutionChanges encountered.
            // null means not configured. otherwise assign to an integer.
            self.qualityLimitation = {
                enabled: true,
                value: 8, // arbitrary default or set from config
                count: 0, // current count of quality limitations from stats
                reset: true, // whether to reset count on bitrate change, by setting base.
                base: 0 // (count - base) is used to get the count.
            };

            self.checkVideoLowInWebcamStats = checkVideoLowInWebcamStats;
            self.resetVideoLowQualityLimitationCount = resetVideoLowQualityLimitationCount;

            self.onVideoFeedCountChange = onVideoFeedCountChange;
            $scope.$on('init-video-feed-count', onVideoFeedCountChange);
            $scope.$on('video-feed-count', onVideoFeedCountChange);

            self.onApplyLowCpuMode = onApplyLowCpuMode;
            $scope.$on('apply-low-cpu-mode', onApplyLowCpuMode);

            //If media server has high CPU, all attendees on that server will be forced into LPM
            self.onApplyLowCpuModeFromServer = onApplyLowCpuModeFromServer;
            $scope.$on('apply-low-cpu-mode-from-server', onApplyLowCpuModeFromServer);

            self.resetPublishVideoLow = resetPublishVideoLow;

            self.skipLowCpuAlert = false;

            // older config and state data for triggering appCpu
            // count = of total CPU reports that are over the high threshold
            // max = number of high CPU reports needed to move to LPM
            // high, low = threshold in percent.
            // tracked is to avoid multiple unncessary tracking in analytics.
            self.videoLowLegacy = {
                threshold: { count: 0, max: 4, high: 80, low: 50 },
                tracked: false
            };

            // The bitrate and framerate can be fine tuned for level1 and level2, with simulcast2.
            // resolution is lower 360 for both level1 and level2.
            self.videoLowDefaultConfig = {
                // cutoff1 - cpu% to go from default (no LPM) to level1 threshold.
                cutoff1Cpu: 50,
                // cutoff2 - cpu% to go from level1 to level2 threshold.
                cutoff2Cpu: 75,
                // recover1 - cpu% to go from level2 to level1 threshold.
                recover1Cpu: 40,
                // recover0 - cpu% to go from level1 to default threshold.
                // using 0 disables this for now, so that it does not recover to no-LPM.
                recover0Cpu: 0,
                // max total bitrate for level1 and level2 of videoLow mode.
                level1Bitrate: 600,
                level2Bitrate: 400,
                // max framerate of substreams 1 and 0 in level1 and level2.
                level1FpsMedium: 15,
                level1FpsLow: 15,
                level2FpsMedium: 8,
                level2FpsLow: 8,
                // triggerCount, recoverCount - is number of times CPU report is needed to trigger cutoff or recover.
                triggerCount: 4,
                recoverCount: 4,
                // recoveredCount - is max number times recovery is done, after that recovery is avoided.
                //   this only applies to level 2 to level 1 recovery.
                recoveredCount: 1,
                // minimum interval in ms between successive CPU event, otherwise event is ignored.
                minInterval: 4500,
                // clearOnStop - whether to clear the data state when publish is stopped.
                clearOnStop: false,
                // maximum number of CPU metrics to keep in samples. for 3min in milliseconds.
                maxSamples: 180000,
                // whether to log videoLowConfig related information. too verbose.
                log: false
            };

            // this is used when flag videoLowConfig is enabled, with initial value from default.
            self.videoLowConfig = null;

            self.videoLowDefaultData = {
                // currentLevel is 0 (no LPM) or 1 or 2.
                currentLevel: 0,
                // triggerCount is number of high CPU reports so far since last switch.
                triggerCount: 0,
                // recoverCount is number of low CPU reports so far since last switch.
                recoverCount: 0,
                // triggeredCount is number of switch (level1 to level2) due to high CPU done so far.
                triggeredCount: 0,
                // recoveredCount is number of recovery (level2 to level1) done so far.
                recoveredCount: 0,
                // last timestamp when CPU event was received to consider minInterval.
                lastTimestamp: 0
            };

            // run time data about video low. only used when videoLowConfig is enabled.
            self.videoLowData = Object.assign({}, self.videoLowDefaultData);

            // metrics and events are stored for upto 3 minutes. each item in this array is
            // {ts, type, value}. ts is timestamp, with most recent item first.
            // type is "cpu" or "transition", and value is either cpuLoadTotal number
            // or level transition event such as "0-to-1".
            self.cpuUsageData = [];

            self.onReceivedCpuMetrics = onReceivedCpuMetrics;
            $scope.$on('received-cpu-metrics-video-room', onReceivedCpuMetrics);

            self.onTriggerCpuMetrics = onTriggerCpuMetrics;
            self.onResetCpuMetrics = onResetCpuMetrics;
            self.onVideoLowCpuMetricsLegacy = onVideoLowCpuMetricsLegacy;
            self.onVideoLowCpuMetrics = onVideoLowCpuMetrics;
            self.addToCpuUsageData = addToCpuUsageData;

            self.adjustVideoLowOnBitrateIfNeeded = adjustVideoLowOnBitrateIfNeeded;
            self.videoLowBitrateResetTimer = null;
        }

        // update state from URL param.
        function initVideoLow() {
            self.setVideoLowConfig(configService.getValue('videoLowConfig') || 'true');

            // whether videoLow is enabled
            //Must be set before calling setInitialBitrate()
            self.setVideoLow('config', configService.getClientValue('videoLow') == 'true', { init: true });

            // whether videoLowCount is enabled
            const videoLowCount = configService.getValue('videoLowCount');
            self.videoLowCount = videoLowCount == 'false' || videoLowCount == '0' ? 0 : parseInt(videoLowCount) || 10; // default 10, if true or NaN

            // whether to use encode time to go to low video mode?
            var useEncodeTime = configService.getValue('useEncodeTime') || true;
            self.encodeTimeThreshold = parseInt(useEncodeTime) || 15;
            self.useEncodeTime = !!(useEncodeTime && useEncodeTime !== 'false');

            // skip low cpu alert
            self.skipLowCpuAlert = configService.getClientValue('skipLowCpuAlert') == 'true';
        }

        // update from URL param and set video low mode from server trigger.
        function initVideoLowAlt() {
            // whether to lower the desired webcam resolution if too many qualityLimitationResolutionChanges found.

            const initialQualityLimitation = { ...self.qualityLimitation };
            const configuredQualityLimitation = configService.getValue('adjustOnQualityLimitation');

            logger.log(
                'initVideoLowAlt',
                'set adjust on quality limitation parameters',
                initialQualityLimitation,
                configuredQualityLimitation
            );

            if (configuredQualityLimitation === 'true') {
                self.qualityLimitation.enabled = true;
            } else if (configuredQualityLimitation === 'false') {
                self.qualityLimitation.enabled = false;
            } else {
                self.qualityLimitation.enabled = true;

                if (configuredQualityLimitation) {
                    self.setConfigObjectFromCSV(self.qualityLimitation, configuredQualityLimitation);
                }
            }

            if (videoroomService.getIsVideoLowFromServer()) {
                logger.log('initVideoLowAlt', 'videoLowFromServer true');
                self.setVideoLow('server', true, { layout: true });
            }
        }

        function setVideoLowConfig(videoLowConfig) {
            if (videoLowConfig && videoLowConfig !== 'false') {
                self.videoLowConfig = Object.assign(self.videoLowConfig || {}, self.videoLowDefaultConfig);
                if (videoLowConfig !== 'true') {
                    self.setConfigObjectFromCSV(self.videoLowConfig, videoLowConfig);
                }
            } else {
                self.videoLowConfig = null;
            }
        }

        // refactored from videoStatsService to check for videoLow mode based on getStats report on webcam.
        function checkVideoLowInWebcamStats(item) {
            if (item.qualityLimitationResolutionChanges && self.qualityLimitation.count >= 0) {
                self.qualityLimitation.count = item.qualityLimitationResolutionChanges;

                const qualityLimitationCount = self.qualityLimitation.count - self.qualityLimitation.base;

                if (self.qualityLimitation.enabled && qualityLimitationCount >= self.qualityLimitation.value) {
                    self.qualityLimitation.count = -1; // to avoid more calls to this function.
                    logger.warn('checkVideoLowInWebcamStats', 'adjust max resolution on quality limitation');
                    self.setVideoLow('limit', true, {});
                }
                delete item.qualityLimitationResolutionChanges; // not needed in CDR.
            }
            // only one time to enable low cpu mode. cannot disable low cpu mode via this method.
            if (
                item.encodeTime &&
                (self.useEncodeTime || self.trackEncodeTime) &&
                self.videoLowState.encodeTime === undefined &&
                item.encodeTime > self.encodeTimeThreshold &&
                !helperService.isElectron()
            ) {
                if (self.trackEncodeTime) {
                    self.trackEncodeTime = false;
                }
                logger.log(
                    'checkVideoLowInWebcamStats',
                    `adjust max resolution on encode time, useEncodeTime=${self.useEncodeTime}`
                );
                if (self.useEncodeTime) {
                    self.setVideoLow('encodeTime', true, { notify: true });
                }
            }
        }

        // called to reset qualityLimitationCount if valid.
        function resetVideoLowQualityLimitationCount() {
            if (self.qualityLimitation.enabled && self.qualityLimitation.reset) {
                if (self.qualityLimitation.count > 0 && self.qualityLimitation.count > self.qualityLimitation.base) {
                    logger.log(
                        'resetVideoLowQualityLimitationCount',
                        `reseting count base to ${self.qualityLimitation.count}`
                    );
                    self.qualityLimitation.base = self.qualityLimitation.count;
                }
            }
        }

        // name is an attribute in videoLowState, and value is true, false or undefined.
        // opt object can have these attributes
        // init: if true then only set the state but do not do anything else.
        // layout: if true then update webcam limit in layout too.
        // notify: if true then show notification via growl service, if value is true.
        function setVideoLow(name, value, opt) {
            if (!self.videoLowState.hasOwnProperty(name)) {
                logger.error('setVideoLow', `incorrect attribute ${name}, ignored`);
                return;
            }

            const previousValue = self.getIsVideoLow();
            const previous = self.videoLowState[name];

            self.videoLowState[name] = value;

            const newValue = self.getIsVideoLow();

            logger.log('setVideoLow', `set ${name}=${value}, state=${JSON.stringify(self.videoLowState)}`);
            if (previousValue !== newValue) {
                self.msgflowEvent('video-low:' + newValue, { state: self.videoLowState, reason: name });
            }

            if (opt && opt.init) {
                return; // no need to continue if this is only initialization
            }

            self.reapplyPublishConstraints();
            self.reapplyPublishBitrate();

            if (previous !== value) {
                if (opt && opt.layout) {
                    self.onLayoutPageLowWebcamLimit(self.getIsVideoLowLayout());
                }

                if (opt && opt.notify && value && (opt.layout || previousValue !== newValue) && !self.skipLowCpuAlert) {
                    // ANYAM-107505: show growl if video count > cutoff
                    if (self.layoutPageData.videoCount > self.layoutPageData.cutoff) {
                        growlService.show(localizationService.translate('DIALOG.LPM_TRIGGERED'), 'success', '');
                    }
                }
            }
        }

        // data.reason is one of the attribute in videoLowState, e.g., screenshare or config.
        function onApplyLowCpuMode(e, data) {
            if (!data || data.value === undefined) {
                logger.error('onApplyLowCpuMode', 'invalid or missing data');
                return;
            }
            if (!data.reason || !self.videoLowState.hasOwnProperty(data.reason)) {
                logger.error('onApplyLowCpuMode', 'invalid or missing reason');
                return;
            }

            var newValue = data.value;
            var previousValue = self.videoLowState[data.reason];
            if (previousValue !== newValue) {
                logger.log('onApplyLowCpuMode', `videoLowState.${data.reason} = ${previousValue}=>${newValue}`);

                const opt = {};
                if (data.reason === 'config') {
                    opt.layout = true;
                }

                self.setVideoLow(data.reason, newValue, opt);
            }
        }

        function onApplyLowCpuModeFromServer() {
            logger.log('onApplyLowCpuModeFromServer', 'called');
            videoroomService.setIsVideoLowFromServer(true);
            self.setVideoLow('server', true, { layout: true, notify: true });
        }

        function onVideoFeedCountChange(e, count) {
            var previousCount = self.videoFeedCount;
            self.videoFeedCount = count;

            var applyConstraints = false;

            if (self.videoLowCount) {
                var previousValue = self.videoLowState.count;
                var newValue = count >= self.videoLowCount ? true : false;
                if (previousValue != newValue) {
                    logger.log('onVideoFeedCountChange', `videoLowOnCount = ${previousValue}=>${newValue}`);
                    self.setVideoLow('count', newValue, { init: true });
                    applyConstraints = true;
                }
            }

            // if fpsAuto cutoff is set for simulcast2, then reapply encodings to change fps
            // when count crosses the cutoff going up or down.
            if (
                self.videocodec == 'h264' &&
                self.useSimulcast2 &&
                self.useSimulcast2 != 'legacy' &&
                self.simulcastFlag &&
                self.configForSimulcast2.fpsAuto &&
                ((previousCount < self.configForSimulcast2.fpsAuto &&
                    self.videoFeedCount >= self.configForSimulcast2.fpsAuto) ||
                    (previousCount >= self.configForSimulcast2.fpsAuto &&
                        self.videoFeedCount < self.configForSimulcast2.fpsAuto))
            ) {
                self.reapplySimulcastEncodings(true);
            } else if (applyConstraints) {
                self.reapplyPublishConstraints();
            }

            if (applyConstraints) {
                self.reapplyPublishBitrate();
            }
        }

        function adjustVideoLowOnBitrateIfNeeded(oldBitrate, newBitrate) {
            if (
                self.bitrateLowConfig.type === 'videoLow' &&
                self.useSimulcast2 &&
                self.simulcastFlag &&
                oldBitrate != newBitrate
            ) {
                const cutoff = self.getSimulcastMinBitrate();
                if (!self.videoLowState.bitrate && newBitrate < cutoff) {
                    logger.log(
                        'adjustVideoLowOnBitrateIfNeeded',
                        `videoLowState.bitrate = true; bitrate ${newBitrate} < cutoff ${cutoff}`
                    );
                    self.setVideoLow('bitrate', true);
                    if (self.bitrateLowConfig.resetAfter) {
                        if (self.videoLowBitrateResetTimer) {
                            $timeout.cancel(self.videoLowBitrateResetTimer);
                            self.videoLowBitrateResetTimer = null;
                        }
                        self.videoLowBitrateResetTimer = $timeout(function () {
                            self.videoLowBitrateResetTimer = null;
                            if (self.videoLowState.bitrate && self.simulcastFlag) {
                                logger.log(
                                    'adjustVideoLowOnBitrateIfNeeded',
                                    `videoLowState.bitrate = false after timeout`
                                );
                                self.setVideoLow('bitrate', false);
                                // TODO: it should change self.bitrate.adjust.video too, and call createVideoBitrateConrol.
                            }
                        }, self.bitrateLowConfig.resetAfter);
                    }
                } else if (self.videoLowState.bitrate && newBitrate >= cutoff) {
                    logger.log(
                        'adjustVideoLowOnBitrateIfNeeded',
                        `videoLowState.bitrate = false; bitrate ${newBitrate} >= cutoff ${cutoff}`
                    );
                    self.setVideoLow('bitrate', false);
                }
            }
        }

        // when webcam publish is stopped.
        function resetPublishVideoLow() {
            self.qualityLimitation.count = 0; // reset on stop.
            self.qualityLimitation.base = 0;
            self.setVideoLow('limit', undefined, { init: true });
            self.setVideoLow('bitrate', undefined, { init: true });
            if (!helperService.isElectron()) {
                self.setVideoLow('encodeTime', undefined, { init: true });
            }
            if (self.videoLowBitrateResetTimer) {
                $timeout.cancel(self.videoLowBitrateResetTimer);
                self.videoLowBitrateResetTimer = null;
            }
            if (self.videoLowConfig && self.videoLowConfig.clearOnStop) {
                Object.assign(self.videoLowData, self.videoLowDefaultData);
                if (self.videoLowState.appCpu || self.videoLowState.appCpu2) {
                    logger.log('resetPublishVideoLow', 'clearOnStop');
                    if (self.videoLowState.appCpu2) {
                        self.addToCpuUsageData('transition', '2-to-1');
                    }
                    if (self.videoLowState.appCpu) {
                        self.addToCpuUsageData('transition', '1-to-0');
                    }
                    self.setVideoLow('appCpu2', false, { init: true });
                    self.setVideoLow('appCpu', false, { init: true });
                    $timeout(function () {
                        // delay this to avoid interfering with any current layout change.
                        if (!self.getIsVideoLowLayout()) {
                            // recovered. update layout.
                            self.onLayoutPageLowWebcamLimit(false);
                        }
                    }, 2000);
                }
            }
            self.addToCpuUsageData('transition', 'unpublish');
        }

        // if any videoLowState attribute is set.
        // if notLimit true, then ignore using limit attribute.
        // if videoLowConfig is enabled to use appCpu2, then can return "lower" in addition to true or false.
        function getIsVideoLow(notLimit) {
            if (self.videoLowState.appCpu2) {
                return 'lower';
            }
            if (!notLimit) {
                return (
                    Object.values(self.videoLowState).findIndex(function (value) {
                        return !!value;
                    }) >= 0
                );
            } else {
                return (
                    Object.entries(self.videoLowState)
                        .filter(function (nv) {
                            return nv[0] !== 'limit';
                        })
                        .map(function (nv) {
                            return nv[1];
                        })
                        .findIndex(function (value) {
                            return !!value;
                        }) >= 0
                );
            }
            // Keep the following alternative implementation for testing.
            // return !!(
            //     self.videoLowState.config ||
            //     self.videoLowState.count ||
            //     self.videoLowState.appCpu ||
            //     self.videoLowState.server ||
            //     self.videoLowState.encodeTime ||
            //     (!notLimit && self.videoLowState.limit) ||
            //     self.videoLowState.screenshare
            // );
        }

        function getIsVideoLowLayout() {
            const appCpu =
                (self.videoLowConfig && self.videoLowState.appCpu2) ||
                (!self.videoLowConfig && self.videoLowState.appCpu);
            return self.videoLowState.config || appCpu || self.videoLowState.server;
        }

        // from Labs UI, trigger events.
        function onTriggerCpuMetrics(value) {
            self.onReceivedCpuMetrics(undefined, { cpuLoadTotal: value });
        }

        function onResetCpuMetrics() {
            Object.assign(self.videoLowData, self.videoLowDefaultData);
            if (self.videoLowState.appCpu || self.videoLowState.appCpu2) {
                if (self.videoLowState.appCpu2) {
                    self.addToCpuUsageData('transition', '2-to-1');
                    self.setVideoLow('appCpu2', false, self.videoLowState.appCpu ? { init: true } : undefined);
                }
                if (self.videoLowState.appCpu) {
                    self.addToCpuUsageData('transition', '1-to-0');
                    self.setVideoLow('appCpu', false);
                }
            }
        }

        // returns true if exceeds the metricThresholds from config.js. code moved from appInsightsService.
        function onReceivedCpuMetrics(ev, transformed) {
            logger.log('onReceivedCpuMetrics', `transformed=${JSON.stringify(transformed)}`);

            // copy old app logic for analytics
            if (transformed.cpuLoadTotal >= self.videoLowLegacy.threshold.high) {
                logger.log('onReceivedCpuMetrics', `high cpu event ${transformed.cpuLoadTotal}`);
                if (!self.videoLowLegacy.tracked) {
                    self.videoLowLegacy.tracked = true;
                    analyticsWrapperService.eventTrack('Meeting - Single High CPU event received');
                }
            }

            if (!self.videoLowConfig) {
                // older app logic
                self.onVideoLowCpuMetricsLegacy(transformed);
            } else {
                self.addToCpuUsageData('cpu', transformed.cpuLoadTotal);

                const now = Date.now();
                if (
                    !self.videoLowData.lastTimestamp ||
                    now >= self.videoLowData.lastTimestamp + self.videoLowConfig.minInterval
                ) {
                    self.videoLowData.lastTimestamp = now;
                    // newer app logic for graceful degradation and two levels.
                    self.onVideoLowCpuMetrics(transformed);
                } else {
                    logger.log('onReceivedCpuMetrics', 'ignored, as too soon');
                }
            }
        }

        // the app logic is moved from appInsightsService to here.
        function onVideoLowCpuMetricsLegacy(transformed) {
            if (meetingService.getEnableAutoPerformanceMode()) {
                if (!self.videoLowState.appCpu && transformed.cpuLoadTotal >= self.videoLowLegacy.threshold.high) {
                    // increment the threshold count because the cpuLoadTotal is >= the high threshold
                    self.videoLowLegacy.threshold.count++;

                    if (self.videoLowLegacy.threshold.count === self.videoLowLegacy.threshold.max) {
                        analyticsWrapperService.eventTrack('Meeting - Low Performance Mode Auto-Enabled');

                        // Send into low performance mode
                        self.setVideoLow('appCpu', true, { layout: true, notify: true });
                    }
                } else {
                    // reset the threshold count because the cpuLoadTotal < the high threshold
                    self.videoLowLegacy.threshold.count = 0;
                }
            }
        }

        // must have videoLowConfig enabled.
        function onVideoLowCpuMetrics(transformed) {
            const data = self.videoLowData,
                config = self.videoLowConfig;

            if (config.log) {
                logger.log('onVideoLowCpuMetrics', `before data=${JSON.stringify(data)}`);
            }

            if (
                (data.currentLevel === 0 && transformed.cpuLoadTotal >= config.cutoff1Cpu) ||
                (data.currentLevel === 1 && transformed.cpuLoadTotal >= config.cutoff2Cpu)
            ) {
                data.triggerCount += 1;
                data.recoverCount = 0;
                if (data.triggerCount === config.triggerCount) {
                    data.triggerCount = data.recoverCount = 0;
                    data.currentLevel += 1;

                    if (data.currentLevel === 1) {
                        analyticsWrapperService.eventTrack('Meeting - Low Performance Mode Auto-Enabled');
                        // Send into low performance mode
                        self.addToCpuUsageData('transition', '0-to-1');
                        self.setVideoLow('appCpu', true, { layout: true });
                    } else if (data.currentLevel === 2) {
                        data.triggeredCount += 1;
                        self.addToCpuUsageData('transition', '1-to-2');
                        self.setVideoLow('appCpu2', true, { layout: true, notify: true });
                    }
                }
            } else if (
                (data.recoveredCount < config.recoveredCount &&
                    data.currentLevel === 2 &&
                    transformed.cpuLoadTotal < config.recover1Cpu) ||
                (data.currentLevel === 1 && transformed.cpuLoadTotal < config.recover0Cpu)
            ) {
                data.triggerCount = 0;
                data.recoverCount += 1;
                if (data.recoverCount === config.recoverCount) {
                    data.triggerCount = data.recoverCount = 0;
                    data.currentLevel -= 1;

                    if (data.currentLevel === 0) {
                        self.addToCpuUsageData('transition', '1-to-0');
                        self.setVideoLow('appCpu', false, { layout: true });
                    } else if (data.currentLevel === 1) {
                        data.recoveredCount += 1;
                        self.addToCpuUsageData('transition', '2-to-1');
                        self.setVideoLow('appCpu2', false, { layout: true });
                    }
                }
            } else {
                data.triggerCount = data.recoverCount = 0;
            }

            if (config.log) {
                logger.log('onVideoLowCpuMetrics', `after data=${JSON.stringify(data)}`);
            }
        }

        function addToCpuUsageData(type, value) {
            if (self.videoLowConfig) {
                const data = self.cpuUsageData,
                    config = self.videoLowConfig;

                const ts = Date.now();
                data.splice(0, 0, { ts, type, value });

                if (config.log) {
                    // use info for local logging only.
                    console.info('addToCpuUsageData', `data=${JSON.stringify(data)}`);
                }
                const cutoff = ts - config.maxSamples;
                let i = data.length - 1;
                while (i >= 0) {
                    var item = data[i];
                    if (item.ts >= cutoff) {
                        break;
                    }
                    --i;
                }
                if (i < data.length - 1) {
                    data.splice(i + 1, data.length - 1 - i);
                }

                if (config.log) {
                    logger.log('addToCpuUsageData', `length=${data.length} type=${type} value=${value}`);
                }

                var checkReduce = !self.videoroom || self.videoLowState.appCpu || self.videoLowState.appCpu2;
                self.updateSimulcastHighCpuState(checkReduce, data);
            }
        }
    }
]);
